var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggregateQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10C4.375 10 4.5 10.125 4.5 10.25V13.25C4.5 13.4062 4.375 13.5 4.25 13.5H3.75C3.59375 13.5 3.5 13.4062 3.5 13.25V10.25C3.5 10.125 3.59375 10 3.75 10H4.25ZM6.25 7C6.375 7 6.5 7.125 6.5 7.25V13.25C6.5 13.4062 6.375 13.5 6.25 13.5H5.75C5.59375 13.5 5.5 13.4062 5.5 13.25V7.25C5.5 7.125 5.59375 7 5.75 7H6.25ZM7.5 9.25C7.5 9.125 7.59375 9 7.75 9H8.25C8.375 9 8.5 9.125 8.5 9.25V13.25C8.5 13.4062 8.375 13.5 8.25 13.5H7.75C7.59375 13.5 7.5 13.4062 7.5 13.25V9.25ZM11.5312 3.0625C11.8125 3.34375 12 3.75 12 4.125V14.5312C12 15.3438 11.3125 16 10.5 16H1.46875C0.65625 16 0 15.3438 0 14.5312V1.53125C0 0.6875 0.65625 0.03125 1.46875 0H7.875C8.25 0 8.65625 0.1875 8.9375 0.46875L11.5312 3.0625ZM8 1.03125V4.03125H10.9688C10.9375 3.9375 10.9062 3.84375 10.8438 3.78125L8.21875 1.15625C8.15625 1.09375 8.0625 1.0625 8 1.03125ZM11 14.5312V5H7.75C7.3125 5 7 4.6875 7 4.28125V1H1.46875C1.21875 1 0.96875 1.25 0.96875 1.53125V14.5312C0.96875 14.7812 1.21875 15.0312 1.46875 15.0312H10.5C10.75 15.0312 11 14.7812 11 14.5312Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregateQuantity);
export default __webpack_public_path__ + "static/media/aggregate_quantity.66f4346b.svg";
export { ForwardRef as ReactComponent };